import {
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import CancelIcon from "@material-ui/icons/Cancel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import clsx from "clsx";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useAuth } from "../../../../context/auth";
import { actionShowSpinner } from "../../../../redux-flow/action/Wrapper/Spinner";
import { editAction, getById } from "../../../../services/actions.service";
import { getMembersByName } from "../../../../services/formCombos.service";
import { deleteAction } from "../../../../services/minutes.service.js";
import {
  getDateFormats,
  getDateTimeLocale,
  getInputDateFormats,
} from "../../../../utils/get-date-time-locale";
import { TYPE_SLOT } from "../../../../utils/StaticLists/index";
import DialogCustom from "../../../Common/DialogCustom";
import { Select } from "../../../Common/Select";
import Textarea from "../../../Common/Textarea";
import ToastMessage from "../../../Common/ToastMessage";
import { actionsStatusOptions, checkAccess } from "../../utils/index";
import ModalBase from "../../utils/ModalBase";
import CommentComponent from "./CommentComponent";
import FollowUpModal from "./FollowUpModal";
import {
  AddFupButton,
  ButtonsContainer,
  FollowIndexRow,
  FollowUpContainer,
  FollowUpDateText,
  FollowUpsContent,
  FollowUpsTitle,
  FollowUpUserNameText,
  ReprogrammingInfo,
} from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  subtitle: {
    ...theme.typography.subtitle1,
  },
  button: {
    fontSize: "1rem",
    fontWeight: "bold",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 12,
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.25rem",
    color: theme.palette.primary.main,
  },
}));

const InfoAction = ({ t, history, actionShowSpinner, location }) => {
  const classes = useStyles();
  const { userAccess } = useAuth();
  const { i18n } = useTranslation();

  const [firstResponsibleOptions, setFirstResponsibleOptions] = useState([]);
  const [focalPointOptions, setFocalPointOptions] = useState([]);
  const [secoundResponsibleOptions, setSecoundResponsibleOptions] = useState(
    []
  );
  const [toastMessage, setToastMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });
  const [actionDeleteDialogOpen, setActionDeleteDialogOpen] = useState(false);
  const [inputFirstResponsibleName, setInputFirstResponsibleName] =
    useState("");
  const [inputFocalPoint, setInputFocalPoint] =
    useState("");
  const [inputSecoundResponsibleName, setInputSecoundResponsibleName] =
    useState("");
  const [fupToEdit, setFupToEdit] = useState();
  const [openFupModal, setOpenFupModal] = useState(false);
  const [actionId, setActionId] = useState();
  const [groupAction, setGroupAction] = useState();
  const [deleteOptionAvailable, setDeleteOptionAvailable] = useState(false);
  const [followUps, setFollowUps] = useState([]);
  const [formValues, setFormValues] = useState({
    committee: "",
    meetDate: new Date(),
    slotType: "",
    anyoneCanRequest: false,
    slotTheme: "",
    actionNumber: "",
    actionDescription: "",
    firstResponsible: undefined,
    focalPoint: undefined,
    secoundResponsible: undefined,
    requester: { name: "" },
    companies: [],
    status: "",
    deadline: new Date(),
    firstDeadline: new Date(),
    minuteStatus: "",
  });
  const [canDeleteActions, setCanDeleteActions] = useState();
  const [canUpdateAction, setCanUpdateAction] = useState();
  const [canUpdateActionFocalPoint, setCanUpdateActionFocalPoint] = useState();
  const [canUpdateOwnFocalAction, setCanUpdateOwnFocalAction] = useState();

  useEffect(() => {
    actionShowSpinner(true);
    setActionId(location.state.action_id);

    getById(location.state.action_id)
      .then((response) => {
        setGroupAction(response.groupAction);

        setDeleteOptionAvailable(response.minuteStatus !== "C");

        setFormValues({
          committee: response?.committe,
          anyoneCanRequest: response?.anyoneCanRequest,
          meetDate: response?.meetDate,
          slotType: TYPE_SLOT[localStorage.getItem("i18nextLng")].find(
            (typeSlot) => typeSlot.id === response.slotType
          )?.name,
          slotTheme: response?.slotTheme,
          actionNumber: response?.actionNumber,
          actionDescription: response?.actionDescription,
          companies: response?.companies.map((company) => ({
            id: company.id,
            name: `${company.companyName} - ${company.companyAbbreviation}`,
          })),
          focalPoint: {
            id: response?.focalPointMemberId,
            name: response?.focalPointMemberName,
          },
          firstResponsible: {
            id: response?.firstResponsibleId,
            name: response?.firstResponsibleName,
          },
          secoundResponsible: {
            id: response?.secoundResponsibleId,
            name: response?.secoundResponsibleName,
          },
          firstResponsibleDirectory: {
            id: response?.firstResponsibleDirectoryId,
            name: response?.firstResponsibleDirectoryName,
          },
          secoundResponsibleDirectory: {
            id: response?.secoundResponsibleDirectoryId,
            name: response?.secoundResponsibleDirectoryName,
          },
          // slotDirectory: { id: response?.slotDirectoryId, name: response?.slotDirectoryName },
          requester: {
            id: response?.requesterId,
            name: response?.requesterName,
          },
          chairpersonValidation: response?.chairPersonValidation
            ? { name: t("menu.actions.validations.v"), id: "v" }
            : { name: t("menu.actions.validations.nv"), id: "nv" },
          status: actionsStatusOptions(localStorage.getItem("i18nextLng")).find(
            (option) => option.id === response.status
          ),
          deadline: response?.deadLine,
          firstDeadline: response?.firstDeadLine,
          minuteStatus: response?.minuteStatus,
        });

        setFollowUps(response.flowups);
      })
      .finally(() => actionShowSpinner(false));
  }, [location.state.action_id]);

  useEffect(() => {
    async function load() {
      if (inputFirstResponsibleName?.length >= 3) {
        const res = await getMembersByName("pt", inputFirstResponsibleName);

        if (res.error?.length > 0) {
          setFirstResponsibleOptions([]);
        }else {
          const list = res.data;
          
          setFirstResponsibleOptions(list);
        }
      } else {
        setFirstResponsibleOptions([]);
      }
      
      if (inputFocalPoint?.length >= 3) {
        const res = await getMembersByName("pt", inputFocalPoint);

        if (res.error?.length > 0) {
          setFocalPointOptions([]);
        }else {
          const list = res.data;
  
          setFocalPointOptions(list);
        }
      } else {
        setFocalPointOptions([]);
      }

      if (inputSecoundResponsibleName?.length >= 3) {
        const res = await getMembersByName("pt", inputSecoundResponsibleName);

        if (res.error?.length > 0) {
          setSecoundResponsibleOptions([]);
        }else { 
          const list = res.data;
          
          setSecoundResponsibleOptions(list);
        }
      } else {
        setSecoundResponsibleOptions([]);
      }
    }

    if (userAccess) {
      const hasAccessToDeleteActions = checkAccess(userAccess, "deleteActions");
      const hasAccessToUpdateAction = checkAccess(userAccess, "updateAction");
      const hasAccessToUpdateOwnFocalAction = checkAccess(userAccess, "updateOwnFocalActions");
      const hasAccessToUpdateActionFocalPoint = checkAccess(userAccess, "updateActionFocalPoint");
      
      setCanDeleteActions(hasAccessToDeleteActions);
      setCanUpdateAction(hasAccessToUpdateAction);
      setCanUpdateOwnFocalAction(hasAccessToUpdateOwnFocalAction);
      setCanUpdateActionFocalPoint(hasAccessToUpdateActionFocalPoint);

      if (!hasAccessToDeleteActions && !hasAccessToUpdateAction && !hasAccessToUpdateActionFocalPoint && !hasAccessToUpdateOwnFocalAction) {
        history.push("/");
      }

      load();
    }
  }, [inputFirstResponsibleName, inputFocalPoint, userAccess, inputSecoundResponsibleName]);

  const handleDeleteAction = async () => {
    const response = await deleteAction(actionId);

    if (
      response.error &&
      response.message.response.data.message === t("error")
    ) {
      setActionDeleteDialogOpen(false);

      setToastMessage({
        open: true,
        content: response.message.response.data.message,
        type: "",
        autoHideDuration: 4000,
      });

      return;
    }

    if (response.error) {
      setActionDeleteDialogOpen(false);

      setToastMessage({
        open: true,
        content: t("menu.actions.actionDeleteError"),
        type: "",
        autoHideDuration: 4000,
      });

      return;
    }

    history.push({
      pathname: "/actions",
      state: {
        actionDeleteSuccess: true,
      },
    });
  };

  const handleEditAction = async () => {
    actionShowSpinner(true);
    try {
      const editActionResponse = await editAction({
        requesterId: formValues.requester.id,
        responsible1:
          formValues.firstResponsible.id ===
            "00000000-0000-0000-0000-000000000000"
            ? null
            : formValues.firstResponsible.id,
        focalPoint:
          formValues?.focalPoint?.id ===
            "00000000-0000-0000-0000-000000000000"
            ? null
            : formValues?.focalPoint?.id,
        responsible2:
          formValues.secoundResponsible.id ===
            "00000000-0000-0000-0000-000000000000"
            ? null
            : formValues.secoundResponsible.id,
        actionDescription: formValues.actionDescription,
        actionNumber: Number(formValues.actionNumber),
        deadline: formValues.deadline,
        ...(formValues.status && { status: formValues.status.id }),
        actionId,
        chairpersonValidation: formValues?.chairpersonValidation?.id,
      });

      if (editActionResponse?.error?.length > 0) {
        setToastMessage({
          open: true,
          content:
            editActionResponse?.error.length < 1
              ? t("error")
              : editActionResponse?.error,
          autoHideDuration: 4000,
          type: "error",
        });

        actionShowSpinner(false);

        return;
      }

      actionShowSpinner(false);

      history.push({
        pathname: "/actions",
        state: { sccessEditAction: true },
      });
    } catch(e) {
      setToastMessage({
        open: true,
        content:
          editActionResponse?.error.length < 1
            ? t("error")
            : editActionResponse?.error,
        autoHideDuration: 4000,
        type: "error",
      });

      actionShowSpinner(false);

      return;
    }
  };

  const onCreateFupSucces = () => {
    setOpenFupModal(false);

    setToastMessage({
      open: true,
      content: t("menu.actions.createFupSuccess"),
      autoHideDuration: 4000,
      type: "success",
    });

    actionShowSpinner(true);
    setActionId(location.state.action_id);

    getById(location.state.action_id)
      .then((response) => {
        setGroupAction(response.groupAction);

        setFormValues({
          ...formValues,
          deadline: response?.deadLine,
        });

        setFollowUps(response.flowups);
      })
      .finally(() => actionShowSpinner(false));
  };

  return (
    <Grid container className={classes.root} style={{ width: "100%" }}>
      <ToastMessage
        message={toastMessage.content}
        type={toastMessage.type || "error"}
        open={toastMessage.open}
        close={() => setToastMessage({ ...toastMessage, open: false })}
      />
      <DialogCustom
        open={actionDeleteDialogOpen}
        handleClose={() => {
          setActionDeleteDialogOpen(false);
        }}
        handleChange={handleDeleteAction}
        title={t(`forms.dialog.warning`)}
        body={t("forms.dialog.textDeleteAction")}
        confirmText={t(`forms.dialog.yes`)}
        cancelText={t(`forms.dialog.no`)}
        alert={true}
      />
      <ModalBase
        open={openFupModal}
        setOpen={setOpenFupModal}
        content={
          <FollowUpModal
            action={actionId}
            actionGroupId={groupAction}
            onCreateFupSucces={onCreateFupSucces}
            t={t}
            setOpenFupModal={setOpenFupModal}
            fupToEdit={fupToEdit}
          />
        }
      />
      <Grid
        container
        item
        direction="row"
        alignItems="center"
        className={classes.spacer}
      >
        <Grid item xs={12} md={6} lg={6}>
          <Typography variant="h4">{t("menu.actions.editTitle")}</Typography>
        </Grid>
        <Grid item>
          <IconButton
            disabled={!deleteOptionAvailable || !canDeleteActions}
            onClick={() => setActionDeleteDialogOpen(true)}
          >
            <CancelIcon className={classes.cancelIcon} />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography
            className={classes.iconText}
            onClick={() => {
              if (canDeleteActions) {
                setActionDeleteDialogOpen(true);
              }
            }}
          >
            {t("menu.actions.delete")}
          </Typography>
        </Grid>
      </Grid>
      <Paper
        elevation={1}
        style={{ padding: 40, marginBottom: 40, width: "100%" }}
      >
        <Grid container direction="row" spacing={3}>
          <Grid item xs={6} lg={6}>
            <Grid container spacing={3} direction="row">
              <Grid item lg={6} xs={12}>
                <TextField
                  name="committeeName"
                  id="committeeName"
                  onChange={(e) =>
                    setFormValues({ ...formValues, committee: e.target.value })
                  }
                  value={formValues.committee}
                  label={t("forms.committee.labels.committeeName")}
                  fullWidth
                  autoComplete="nope"
                  disabled
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <KeyboardDatePicker
                  autoOk
                  disableToolbar
                  variant="inline"
                  format={getInputDateFormats(i18n.language)}
                  id="date-picker-inline"
                  fullWidth
                  required
                  label={t("forms.meetDate")}
                  value={formValues.meetDate}
                  onChange={(date) =>
                    setFormValues({ ...formValues, meetDate: date })
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  disabled
                />
              </Grid>
              <Grid item lg={3} xs={12}>
                <TextField
                  name="slotType"
                  id="slotType"
                  label={t("slots.type")}
                  onChange={(e) =>
                    setFormValues({ ...formValues, slotType: e.target.value })
                  }
                  value={formValues.slotType}
                  fullWidth
                  autoComplete="nope"
                  disabled
                />
              </Grid>
              <Grid item lg={9} xs={12}>
                <Textarea
                  disabled
                  name="theme"
                  id="theme"
                  required={true}
                  onChange={(e) =>
                    setFormValues({ ...formValues, slotTheme: e.target.value })
                  }
                  value={formValues.slotTheme}
                  label={t("slots.theme")}
                />
              </Grid>
              {/* <Grid item lg={6} xs={12}>
                <Select
                  id="slotDirectorship"
                  value={formValues.slotDirectory}
                  options={[formValues.slotDirectory]}
                  disabled
                  label={t("slots.board")}
                />
              </Grid> */}
              <Grid item lg={6} xs={6}>
                <Textarea
                  disabled
                  name="action"
                  id="action"
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      actionDescription: e.target.value,
                    })
                  }
                  value={formValues.actionDescription}
                  label={t("forms.minutes.actions.actionDescription")}
                />
              </Grid>

              <Grid item lg={6} xs={6}>
                <Select
                  id="companies"
                  options={formValues.companies}
                  getOptionSelected={(option, value) => option.id === value.id}
                  value={formValues.companies}
                  label={t("slots.companies")}
                  multiple={true}
                  disabled={true}
                  renderTags={(selectedValues) => {
                    return selectedValues.map((option) => (
                      <Chip
                        className={classes.chip}
                        key={option.id}
                        disabled
                        onDelete={() => {
                          setValue({
                            ...objValue,
                            companies: objValue.companies.filter(
                              (v) => v.id !== option.id
                            ),
                          });
                        }}
                        onClick={() => {
                          setValue({
                            ...objValue,
                            companies: objValue.companies.filter(
                              (v) => v.id !== option.id
                            ),
                          });
                        }}
                        variant="outlined"
                        label={option.name}
                      />
                    ));
                  }}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <TextField
                  id="requester"
                  onChange={(e) =>
                    setFormValues({ ...formValues, requester: e.target.value })
                  }
                  value={
                    formValues.anyoneCanRequest
                      ? t("menu.slot.anyone")
                      : formValues.requester?.name
                  }
                  label={t("forms.minutes.actions.requesterName")}
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <TextField
                  name="actionNumber"
                  id="actionNumber"
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      actionNumber: e.target.value,
                    })
                  }
                  value={formValues.actionNumber}
                  label={t("forms.minutes.actions.actionNumber")}
                  fullWidth
                  autoComplete="nope"
                  disabled
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <Select
                  setValue={(value) => {
                    setFormValues({ ...formValues, focalPoint: value });
                  }}
                  value={formValues.focalPoint}
                  id="focalPoint"
                  options={focalPointOptions || []}
                  inputValue={inputFocalPoint}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setInputFocalPoint(newInputValue);
                  }}
                  label={t("forms.minutes.actions.focalPoint")}
                  disabled={!canUpdateActionFocalPoint}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <Select
                  setValue={(value) => {
                    setFormValues({ ...formValues, firstResponsible: value });
                  }}
                  value={formValues.firstResponsible}
                  id="responsibleName"
                  options={firstResponsibleOptions || []}
                  inputValue={inputFirstResponsibleName}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setInputFirstResponsibleName(newInputValue);
                  }}
                  label={t("forms.minutes.actions.responsibleName")}
                  disabled={!canUpdateAction || (formValues.minuteStatus !== "C" && formValues.minuteStatus !== "EA")}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <Select
                  id="firstResponsibleDirectory"
                  value={formValues.firstResponsibleDirectory}
                  options={[formValues.firstResponsibleDirectory]}
                  disabled
                  label={t("menu.actions.firstResponsibleDirectory")}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <Select
                  value={formValues.secoundResponsible}
                  setValue={(value) => {
                    setFormValues({ ...formValues, secoundResponsible: value });
                  }}
                  id="secoundResponsibleName"
                  options={secoundResponsibleOptions || []}
                  inputValue={inputSecoundResponsibleName}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setInputSecoundResponsibleName(newInputValue);
                  }}
                  label={t("forms.minutes.actions.secoundResponsibleName")}
                  disabled={!canUpdateAction || (formValues.minuteStatus !== "C" && formValues.minuteStatus !== "EA")}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <Select
                  id="secoundResponsibleDirectory"
                  value={formValues.secoundResponsibleDirectory}
                  options={[formValues.secoundResponsibleDirectory]}
                  disabled
                  label={t("menu.actions.secoundResponsibleDirectory")}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <KeyboardDatePicker
                  autoOk
                  disabled
                  disableToolbar
                  variant="inline"
                  format={getInputDateFormats(i18n.language)}
                  id="date-picker-inline"
                  fullWidth
                  label={t("forms.minutes.actions.firstDeadline")}
                  value={formValues.firstDeadline}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Select
                  id="status"
                  options={actionsStatusOptions(
                    localStorage.getItem("i18nextLng")
                  )}
                  value={formValues.status}
                  setValue={(value) => {
                    setFormValues({ ...formValues, status: value });
                  }}
                  label={t("menu.actions.status")}
                  disabled={!canUpdateAction}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <KeyboardDatePicker
                  autoOk
                  disabled
                  disableToolbar
                  variant="inline"
                  format={getInputDateFormats(i18n.language)}
                  id="date-picker-inline"
                  fullWidth
                  label={t("forms.minutes.actions.deadline")}
                  value={formValues.deadline}
                  onChange={(date) => {
                    setFormValues({ ...formValues, deadline: date });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>

              <ButtonsContainer>
                <Button
                  variant="outlined"
                  className={classes.buttonOutlined}
                  onClick={() => history.push("/actions")}
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant="outlined"
                  className={classes.button}
                  onClick={handleEditAction}
                  disabled={!canUpdateAction && !canUpdateActionFocalPoint}
                >
                  {t("forms.committee.buttons.save")}
                </Button>
              </ButtonsContainer>
            </Grid>
          </Grid>
          <Grid item xs={6} lg={6}>
            <FollowUpsTitle>
              <Typography className={clsx(classes.title)}>
                {t("menu.actions.followUps")}
              </Typography>
              <AddFupButton
                color="primary"
                aria-label="add"
                size="small"
                onClick={() => {
                  setFupToEdit(undefined);
                  setOpenFupModal(true);
                }}
                disabled={!canUpdateAction && !canUpdateOwnFocalAction}
              >
                <Add />
              </AddFupButton>
            </FollowUpsTitle>

            <Divider className={classes.spacer} />

            <FollowUpsContent>
              {followUps?.map((followUp) => (
                <FollowUpContainer
                  key={followUp.id}
                  onClick={() => {
                    setFupToEdit({
                      comment: followUp?.commentes,
                      fupDate: followUp?.createDate,
                      reprogram: followUp?.remarked,
                      rescheduleDate: followUp?.newDeadLine,
                      id: followUp?.id,
                    });

                    setOpenFupModal(true);
                  }}
                >
                  <FollowIndexRow>
                    <FollowUpUserNameText>
                      {`${followUp?.requestName} - `}
                    </FollowUpUserNameText>

                    <FollowUpDateText>
                      {followUp?.createDate &&
                        format(
                          new Date(followUp?.createDate),
                          getDateFormats(i18n.language),
                          { locale: getDateTimeLocale(i18n.language) }
                        )}
                    </FollowUpDateText>
                  </FollowIndexRow>

                  <FollowIndexRow>
                      <CommentComponent comment={followUp?.commentes}/>
                  </FollowIndexRow>

                  {followUp?.remarked && (
                    <ReprogrammingInfo>
                      Reprogramado para:{" "}
                      {followUp?.newDeadLine &&
                        format(
                          new Date(followUp?.newDeadLine),
                          getDateFormats(i18n.language),
                          { locale: getDateTimeLocale(i18n.language) }
                        )}
                    </ReprogrammingInfo>
                  )}
                </FollowUpContainer>
              ))}
            </FollowUpsContent>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

const withRouterActions = withRouter(InfoAction);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const InfoActionConnect = connect(null, mapDispatchToProps)(withRouterActions);

export default withTranslation()(InfoActionConnect);
